import React from 'react';

const MegaMenu = ({ links }) => {
    return (
        <ul className='mega-menu'>
            {links.map((link, index) => (
                <li className='mega-menu__item' key={index}>
                    <a className={`mega-menu__link ${link.isSelected ? 'mega-menu__link--selected' : ''}`} href={link.url}>{link.name}</a>
                    {link.links?.length > 0 &&
                        <div className='mega-menu__container'>
                            <div className='mega-menu__wrapper'>
                                {link.links?.map((link, index) => (
                                    <a href={link.url} key={index}>{link.name}</a>
                                ))}
                            </div>
                        </div> 
                    }
                </li>
            ))}
        </ul>
    );
};

export default MegaMenu;
